import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'
import _imports_1 from '@/assets/img/elipse_menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-ec43e9d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "myresponse overflow-x-hide",
  style: {"background":"#eeeff0"}
}
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = {
  class: "row no-margin",
  style: {"overflow":"hidden !important"}
}
const _hoisted_4 = { class: "col-md-12 flex-container" }
const _hoisted_5 = {
  id: "responseModal",
  class: "modal fade myresponse-modal",
  "aria-labelledby": "responseModalLabel",
  "data-bs-backdrop": "false",
  "data-bs-keyboard": "false"
}
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = { class: "modal-header !tw-justify-between" }
const _hoisted_8 = { class: "response-modal-heading float-left" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body-before" }, null, -1))
const _hoisted_13 = { class: "modal-questions" }
const _hoisted_14 = { class: "modal-questions-sec" }
const _hoisted_15 = { class: "modal-questions-heading" }
const _hoisted_16 = { class: "modal-questions-heading-2" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "modal-QA" }
const _hoisted_19 = { class: "question-class" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " : ", -1))
const _hoisted_21 = { class: "answer-class" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div-separator" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body-after" }, null, -1))
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = { class: "btn-container" }
const _hoisted_26 = { class: "right-menu" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerlogo = _resolveComponent("headerlogo")!
  const _component_brandpattern = _resolveComponent("brandpattern")!
  const _component_errorhandler = _resolveComponent("errorhandler")!
  const _component_sidebar = _resolveComponent("sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-11", _ctx.showMenu ? 'opacity-8' : ''])
        }, [
          _createVNode(_component_headerlogo, { "page-type": '404' }),
          _createElementVNode("div", {
            class: "row no-padding main-body h-100",
            style: _normalizeStyle({ height: _ctx.windowHeight })
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_brandpattern, {
                page: "MYRESPONSES",
                class: "!tw-top-[30px]"
              })
            ])
          ], 4)
        ], 2),
        (_ctx.showProspectCallbackError || null)
          ? (_openBlock(), _createBlock(_component_errorhandler, {
              key: 0,
              "prospect-callback-error-msg": _ctx.prospectCallbackErrorMsg,
              onResetShowProspectCallbackError: _ctx.resetShowProspectCallbackError
            }, null, 8, ["prospect-callback-error-msg", "onResetShowProspectCallbackError"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "modal-dialog overflow-y-hide",
            role: "document",
            style: _normalizeStyle({ height: _ctx.modalDialogHeight })
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getUiText("app-prospect-questions-responses-heading-1")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickContinue && _ctx.onClickContinue(...args)))
                }, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", {
                  class: "modal-body-sec",
                  style: _normalizeStyle({ height: _ctx.modalBodySecHeight })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProsQstnGroupsData, (item, itemIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: itemIndex,
                      class: "modal-text"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", null, _toDisplayString(itemIndex + 1) + ".", 1),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(item.name), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "response-modal-edit",
                            onClick: ($event: any) => (_ctx.onClickEdit(itemIndex))
                          }, _toDisplayString(_ctx.getUiText("app-nav-link-edit-1")), 9, _hoisted_17)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.prospect_questions, (item2, itemIndex2) => {
                          return (_openBlock(), _createElementBlock("div", { key: itemIndex2 }, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createTextVNode(_toDisplayString(item2.name) + " ", 1),
                                _hoisted_20
                              ]),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(item2.displayVal), 1)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _hoisted_22
                    ]))
                  }), 128))
                ], 4),
                _hoisted_23
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn great-btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickContinue && _ctx.onClickContinue(...args)))
                  }, _toDisplayString(_ctx.getUiText(
                        "app-prospect-questions-responses-button-continue-1",
                      )), 1)
                ])
              ])
            ])
          ], 4)
        ]),
        _createElementVNode("div", {
          class: "col-md-1 no-padding lg-menu-view",
          style: _normalizeStyle({ 'min-height': _ctx.dyn_height })
        }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", {
              class: "elipse-menu",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.slideMenu && _ctx.slideMenu(...args)))
            }, _hoisted_28)
          ])
        ], 4),
        _createVNode(_component_sidebar, {
          "show-menu": _ctx.showMenu,
          onMyResponse: _ctx.myResponse,
          onCreateAccount: _ctx.createAccount,
          onCloseMenu: _ctx.closeMenu
        }, null, 8, ["show-menu", "onMyResponse", "onCreateAccount", "onCloseMenu"])
      ])
    ])
  ]))
}